(()=>{
 if(customElements.get('park-pdp-hero'))return;
 class ParkPDP extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();this.signal=this.controller.signal;
   this.data=JSON.parse(this.querySelector('[data-pdp-data]').textContent);
   this.panel=this.querySelector('.park-pdp-panel');this.stage=this.querySelector('.park-pdp-stage');
   this.slides=[...this.querySelectorAll('[data-slide]')];this.index=0;
   this.form=this.querySelector('form');this.variantInput=this.form?.elements.namedItem('id');this.planInput=this.querySelector('[data-plan]');
   this.money=new Intl.NumberFormat(this.data.locale,{style:'currency',currency:this.data.currency});this.moneyWhole=new Intl.NumberFormat(this.data.locale,{style:'currency',currency:this.data.currency,minimumFractionDigits:0,maximumFractionDigits:0});
   this.setupVideos();this.setupGallery();this.setupModels();
   const prime=this.querySelector('.park-pdp-prime');
   if(prime)this.on(prime,'toggle',()=>{if(this.form)this.update();});
   this.syncKlaviyoConsent();
   this.on(window,'CookiebotOnConsentReady',()=>this.syncKlaviyoConsent());
   this.on(this,'click',e=>{
    if(this.dataset.primeMember==='true'&&e.target.closest('[data-prime-toggle]')){e.preventDefault();return;}
    if(e.target.closest('[data-klaviyo-renew]')){window.Cookiebot?.renew();return;}
    if(e.target.closest('[data-presale-open],[data-bis-notify]')&&!window.ParkKlaviyoConsent?.allowed()){e.preventDefault();this.syncKlaviyoConsent();return;}
    const presale=e.target.closest('[data-presale-open]');if(presale&&this.dataset.presaleFormId){window._klOnsite=window._klOnsite||[];window._klOnsite.push(['openForm',this.dataset.presaleFormId]);}
    if(e.target.closest('[data-bis-notify]'))e.preventDefault();
    const qty=e.target.closest('[data-quantity]');if(qty&&this.form){const input=this.form.elements.quantity;input.value=Number(input.value)+Number(qty.dataset.quantity)*(Number(input.step)||1);this.update();}
    if(e.target.closest('[data-next]'))this.show(this.index+1);
    if(e.target.closest('[data-prev]'))this.show(this.index-1);
    const thumb=e.target.closest('[data-thumb]');if(thumb)this.show(Number(thumb.dataset.thumb));
   });
   this.on(this.stage,'keydown',e=>{if(e.target.closest('video,iframe,model-viewer'))return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}});
   this.setupSwipe();
   if(this.form){
    this.on(this.form,'change',e=>this.update(e.target.matches('[data-variant]')));
    this.on(this.form,'submit',async e=>{
     e.preventDefault();this.update();const variant=this.variant();const button=this.querySelector('[data-add]');
     if(!variant?.available||button.disabled||!this.form.reportValidity())return;
     const item={id:variant.id,quantity:Number(this.form.elements.quantity.value)};if(this.planInput?.value)item.selling_plan=Number(this.planInput.value);
     try{await window.ParkPDPCart.add([item],{button,status:this.querySelector('[data-status]')});}catch(_){}finally{this.update();}
    });
    this.sticky=this.querySelector('[data-sticky-buy]');
    if(this.sticky){
     this.stickySizeObserver=new ResizeObserver(()=>document.documentElement.style.setProperty('--park-pdp-buy-height',`${this.sticky.getBoundingClientRect().height}px`));
     this.stickySizeObserver.observe(this.sticky);
    }
    // Only show after the normal purchase button has passed above the viewport.
    this.mainBuyPassed=false;
    const scheduleSticky=()=>{if(this.stickyFrame)return;this.stickyFrame=requestAnimationFrame(()=>{this.stickyFrame=null;this.measureSticky();});};
    this.on(window,'scroll',scheduleSticky,{passive:true,capture:true});
    this.on(window,'resize',scheduleSticky);
    this.measureSticky();
    this.stickyObserver=new MutationObserver(()=>this.syncSticky());
    this.stickyObserver.observe(this.querySelector('[data-add]'),{attributes:true,attributeFilter:['disabled','aria-busy']});
    this.stickyObserver.observe(this.querySelector('[data-status]'),{childList:true,subtree:true,characterData:true});
    this.update();
    if(new URL(location.href).searchParams.has('variant')){const selected=this.variant();const media=this.slides.findIndex(s=>s.dataset.mediaId===String(selected?.featured_media_id));if(media>=0)this.show(media);}
    this.on(document,'theme:cartchanged',()=>this.refreshCart());
   }
   this.on(window,'wheel',e=>{
    if(!this.scrollEnabled(e)||e.ctrlKey||e.metaKey||Math.abs(e.deltaX)>Math.abs(e.deltaY)||!e.deltaY)return;
    const max=this.panel.scrollHeight-this.panel.clientHeight,anchor=this.anchor();
    if(max<1||window.scrollY>anchor+1&&e.deltaY>0||window.scrollY<anchor-1&&e.deltaY<0&&this.panel.scrollTop===0)return;
    e.preventDefault();this.route(e.deltaY*(e.deltaMode===1?20:e.deltaMode===2?innerHeight:1));
   },{passive:false});
   this.on(window,'keydown',e=>{
    if(!this.scrollEnabled(e)||e.defaultPrevented||e.ctrlKey||e.metaKey||e.altKey||e.target.closest('input,textarea,select,button,a,summary,[contenteditable],video,model-viewer'))return;
    const distance=innerHeight*.85;let delta={ArrowDown:48,ArrowUp:-48,PageDown:distance,PageUp:-distance}[e.key];if(e.code==='Space')delta=e.shiftKey?-distance:distance;
    if(delta!=null){const max=this.panel.scrollHeight-this.panel.clientHeight;if(max>0&&!(scrollY>this.anchor()+1&&delta>0)&&!(scrollY<this.anchor()-1&&delta<0&&this.panel.scrollTop===0)){e.preventDefault();this.route(delta);}}
    if(e.key==='Home')this.panel.scrollTop=0;if(e.key==='End')this.panel.scrollTop=this.panel.scrollHeight;
   });
   this.on(document,'click',e=>{const a=e.target.closest('a[href^="#"]');if(!a)return;const id=a.getAttribute('href').slice(1);const target=document.getElementById(id);if(target&&this.contains(target)){target.closest('details')?.setAttribute('open','');}else if(target)this.panel.scrollTop=this.panel.scrollHeight;});
   this.on(window,'hashchange',()=>this.revealHash());
   this.on(document,'shopify:block:select',e=>{if(!this.contains(e.target))return;const slide=e.target.closest('[data-slide]');if(slide)this.show(this.slides.indexOf(slide));e.target.closest('details')?.setAttribute('open','');});
   this.resize=new ResizeObserver(()=>this.measure());this.resize.observe(this.querySelector('.park-pdp-gallery'));this.resize.observe(this.querySelector('.park-pdp-panel-inner'));
   const pageHeader=document.querySelector('.section-header')||document.querySelector('#pageheader');if(pageHeader)this.resize.observe(pageHeader);
   this.on(window,'resize',()=>this.measure());this.measure();this.revealHash();
  }
  syncKlaviyoConsent(){
   const controls=this.querySelector('[data-klaviyo-controls]'),help=this.querySelector('[data-klaviyo-consent]'),renew=this.querySelector('[data-klaviyo-renew]');
   if(!controls||!help||!renew)return;
   const allowed=!!window.ParkKlaviyoConsent?.allowed();
   controls.hidden=!allowed;help.hidden=allowed;renew.disabled=typeof window.Cookiebot?.renew!=='function';
  }
  on(target,type,handler,options={}){target.addEventListener(type,handler,{...options,signal:this.signal});}
  variant(){return this.data.variants.find(v=>String(v.id)===this.variantInput?.value);}
  update(variantChanged=false){
   const v=this.variant(),input=this.form.elements.quantity,button=this.querySelector('[data-add]');
   const inCart=(this.data.cart_items||[]).filter(i=>String(i.variant_id)===String(v?.id)).reduce((sum,i)=>sum+i.quantity,0);const rule=ParkPDPCore.remaining(v?.quantity_rule,inCart);input.min=rule.min||1;input.step=rule.increment||1;if(rule.max!=null)input.max=rule.max;else input.removeAttribute('max');
   input.value=ParkPDPCore.quantity(input.value,rule);
   if(this.planInput){
    for(const option of this.planInput.options)option.disabled=!!option.value&&!v?.selling_plan_allocations.some(a=>String(a.selling_plan_id)===option.value);
    if(this.planInput.selectedOptions[0]?.disabled)this.planInput.value=[...this.planInput.options].find(o=>!o.disabled)?.value||'';
   }
   const amount=ParkPDPCore.price(v,Number(input.value)+inCart,this.planInput?.value);
   const memberActive=this.dataset.primeMember==='true'&&!this.planInput?.value;
   const displayAmount=ParkPDPCore.memberPrice(amount,memberActive,true);
   const regularPrice=this.querySelector('[data-price]');
   const originalPrice=this.querySelector('[data-prime-original]');
   if(originalPrice){originalPrice.hidden=!memberActive||amount==null;originalPrice.textContent=amount==null?'':this.money.format(amount/100);}
   regularPrice.textContent=displayAmount==null?'':this.money.format(displayAmount/100);
   const memberPrice=this.querySelector('[data-prime-price]');
   // Logged-in members get the member display automatically; guest comparison remains optional.
   const layout1c=this.dataset.layout==='1c';
   if(memberPrice){
    const enabled=!memberActive&&!!this.querySelector('.park-pdp-prime')?.open;
    const prices=ParkPDPCore.primeComparison(amount);
    this.querySelector('[data-prime-toggle]').setAttribute('aria-checked',String(this.dataset.primeMember==='true'||enabled));
    memberPrice.hidden=!enabled||!prices;
    regularPrice.classList.remove('park-pdp-price--compared');
    if(prices){
     memberPrice.querySelector('[data-prime-amount]').textContent=this.money.format(prices.member/100);
    }
   }
   const total=displayAmount==null?null:displayAmount*Number(input.value);
   this.querySelector('[data-total]').textContent=total==null?'':layout1c&&total%100===0?this.moneyWhole.format(total/100):this.money.format(total/100);
   button.disabled=this.dataset.inventoryMode==='presale'||!v?.available||amount==null||(this.data.requires_selling_plan&&!this.planInput?.value)||(rule.max!=null&&rule.max<rule.min)||button.getAttribute('aria-busy')==='true';
   this.querySelector('[data-add-label]').textContent=!v?this.data.strings.unavailable:!v.available?this.data.strings.soldOut:button.disabled&&button.getAttribute('aria-busy')!=='true'?this.data.strings.unavailable:this.data.strings.add;
   this.querySelector('[data-quantity="-1"]').disabled=Number(input.value)<=Number(input.min);
   this.querySelector('[data-quantity="1"]').disabled=input.max!==''&&Number(input.value)>=Number(input.max);
   this.updateInventory(v);
   this.syncSticky();
   if(variantChanged&&v){
    const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
    const media=this.slides.findIndex(s=>s.dataset.mediaId===String(v.featured_media_id));if(media>=0)this.show(media);
    this.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{variant:v}}));
    if(window.jQuery)window.jQuery(this).trigger('variantChanged',[v,this.data]);
   }
  }
  measureSticky(){
   this.mainBuyPassed=this.querySelector('[data-add]').getBoundingClientRect().bottom<=0;
   this.syncSticky();
  }
  syncSticky(){
   if(!this.sticky)return;
   const source=this.querySelector('[data-add]'),button=this.querySelector('[data-sticky-add]');
   this.sticky.hidden=this.dataset.inventoryMode==='presale'||!this.mainBuyPassed;
   button.disabled=source.disabled;
   button.setAttribute('aria-busy',String(source.getAttribute('aria-busy')==='true'));
   this.querySelector('[data-sticky-label]').textContent=this.querySelector('[data-add-label]').textContent;
   this.querySelector('[data-sticky-total]').textContent=this.querySelector('[data-total]').textContent;
   const variant=this.variant(),selection=this.querySelector('[data-sticky-selection]');
   const title=this.querySelector('.park-pdp-product-title, h1').textContent.trim();
   selection.querySelector('[data-sticky-title]').textContent=title;
   selection.querySelector('[data-sticky-variant]').textContent=[Number(this.form.elements.quantity.value)>1?`${this.form.elements.quantity.value} ×`:null,variant?.title!=='Default Title'?variant?.title:null].filter(Boolean).join(' ');
   const status=this.querySelector('[data-sticky-status]');status.textContent=this.querySelector('[data-status]').textContent;status.hidden=!status.textContent;
  }
  updateInventory(variant){
   const inventory=window.ParkPDPInventory?.state(this.dataset.inventoryMode,variant,this.dataset.presaleFormId);
   if(!inventory)return;
   const purchase=this.querySelector('[data-purchase]'),notice=this.querySelector('[data-inventory]'),notify=this.querySelector('[data-bis-notify]');
   if(purchase)purchase.hidden=!inventory.showPurchase;
   if(notice)notice.hidden=!inventory.presale&&!inventory.showNotify;
   if(notify)notify.hidden=!inventory.showNotify;
  }
  async refreshCart(){try{const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();if(!this.isConnected)return;this.data.cart_items=cart.items||[];this.update();}catch(_){} }
  setupVideos(){
   this.querySelectorAll('[data-video-sound]').forEach(button=>{
    const video=button.closest('[data-slide]').querySelector('video');if(!video)return;
    const sync=()=>{const muted=video.muted||video.volume===0;button.dataset.muted=String(muted);const label=muted?button.dataset.unmuteLabel:button.dataset.muteLabel;button.setAttribute('aria-label',label);button.title=label;};
    this.on(button,'click',()=>{const muted=video.muted||video.volume===0;video.muted=!muted;if(muted&&video.volume===0)video.volume=1;sync();});
    this.on(video,'volumechange',sync);
    this.on(video,'play',()=>{if(video.closest('[data-slide]').hidden)video.pause();});
    button.hidden=false;sync();
   });
  }
  setupGallery(){
   const container=this.querySelector('.park-pdp-thumbnails');container.replaceChildren();
   this.slides.forEach((slide,i)=>{const button=document.createElement('button');button.type='button';button.dataset.thumb=i;button.setAttribute('aria-label',`${this.data.strings.chooseMedia} ${i+1}`);const source=slide.querySelector('img');if(source){const img=document.createElement('img');const thumbSize=this.dataset.layout==='1c'?160:64;img.alt='';img.loading='lazy';img.width=thumbSize;img.height=thumbSize;
    const url=new URL(source.getAttribute('src'),location.href);
    if(url.hostname==='cdn.shopify.com'||url.pathname.startsWith('/cdn/shop/')){
     url.pathname=url.pathname.replace(/_\d+x\d*(?=\.[^.]+$)/,'');
     url.searchParams.delete('height');url.searchParams.set('width',String(thumbSize));
     const retina=new URL(url);retina.searchParams.set('width',String(thumbSize*2));img.sizes=this.dataset.layout==='1c'?'(max-width: 760px) 17vw, 120px':'64px';img.srcset=`${url.href} ${thumbSize}w, ${retina.href} ${thumbSize*2}w`;img.src=url.href;
    }else img.src=source.getAttribute('src');
    button.append(img);}else button.textContent=String(i+1);container.append(button);});
   this.show(0);this.querySelector('.park-pdp-gallery-nav').hidden=this.slides.length<2;container.hidden=this.slides.length<2;
  }
  setupSwipe(){
   this.on(this.stage,'pointerdown',e=>{
    if(e.button>0||!e.isPrimary||this.slides.length<2||e.target.closest('button,a,video,iframe,model-viewer'))return;
    this.resetSwipe();
    this.swipe={id:e.pointerId,x:e.clientX,y:e.clientY,dx:0,width:this.stage.getBoundingClientRect().width,active:false};
   });
   this.on(this.stage,'pointermove',e=>{
    const drag=this.swipe;if(!drag||drag.id!==e.pointerId||drag.finishing)return;
    const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
    if(!drag.active){
     if(Math.max(Math.abs(dx),Math.abs(dy))<8)return;
     if(Math.abs(dy)>=Math.abs(dx)){this.resetSwipe();return;}
     drag.active=true;this.stage.setPointerCapture(e.pointerId);
    }
    if(e.cancelable)e.preventDefault();
    drag.dx=Math.max(-drag.width,Math.min(drag.width,dx));
    const direction=drag.dx<0?1:-1;
    const neighbor=this.slides[(this.index+direction+this.slides.length)%this.slides.length];
    if(drag.neighbor!==neighbor){
     if(drag.neighbor)this.restoreSwipeSlide(drag.neighbor);
     drag.neighbor=neighbor;neighbor.hidden=false;neighbor.inert=true;neighbor.setAttribute('aria-hidden','true');
    }
    drag.direction=direction;
    this.slides[this.index].style.transform=`translateX(${drag.dx}px)`;
    neighbor.style.transform=`translateX(${drag.dx+direction*drag.width}px)`;
   },{passive:false});
   const finish=e=>{
    const drag=this.swipe;if(!drag||drag.id!==e.pointerId||drag.finishing)return;
    if(!drag.active){this.resetSwipe();return;}
    drag.finishing=true;
    const commit=e.type==='pointerup'&&Math.abs(drag.dx)>=Math.min(70,drag.width*.2);
    const next=this.index+(commit?drag.direction:0);
    const current=this.slides[this.index],neighbor=drag.neighbor;
    const distance=commit?-drag.direction*drag.width:0;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduced){this.resetSwipe();this.show(next);return;}
    current.style.transition='transform 220ms ease-out';neighbor.style.transition='transform 220ms ease-out';
    current.style.transform=`translateX(${distance}px)`;
    neighbor.style.transform=`translateX(${distance+drag.direction*drag.width}px)`;
    this.swipeTimer=setTimeout(()=>{this.resetSwipe();this.show(next);},230);
   };
   this.on(this.stage,'pointerup',finish);this.on(this.stage,'pointercancel',finish);
   this.on(this.stage,'lostpointercapture',e=>{if(this.swipe&&!this.swipe.finishing)finish(e);});
   this.on(window,'resize',()=>this.resetSwipe());
  }
  restoreSwipeSlide(slide){
   slide.hidden=true;slide.inert=false;slide.removeAttribute('aria-hidden');
   slide.style.removeProperty('transform');slide.style.removeProperty('transition');
  }
  resetSwipe(){
   clearTimeout(this.swipeTimer);
   const drag=this.swipe;this.swipe=null;if(!drag)return;
   if(drag.neighbor)this.restoreSwipeSlide(drag.neighbor);
   const current=this.slides[this.index];current?.style.removeProperty('transform');current?.style.removeProperty('transition');
   if(this.stage.hasPointerCapture(drag.id))this.stage.releasePointerCapture(drag.id);
  }
  show(index){
   this.resetSwipe();
   if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;
   this.slides.forEach((slide,i)=>{
    const entering=slide.hidden||!this.galleryReady;slide.hidden=i!==this.index;
    slide.querySelectorAll('video').forEach(video=>{if(slide.hidden)video.pause();else if(entering){video.muted=true;video.play().catch(()=>{});}});
    slide.querySelectorAll('iframe').forEach(frame=>{
     const gatedVideo=frame.closest('park-youtube-video');
     if(gatedVideo){gatedVideo.sync?.();return;}
     if(slide.hidden){if(frame.dataset.played){frame.src=frame.src;delete frame.dataset.played;}}
     else frame.dataset.played='true';
    });
   });
   this.galleryReady=true;
   this.querySelectorAll('[data-thumb]').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));
   this.revealThumbnail();
   this.modelPlayers?.forEach(({model,player})=>{if(model.closest('[data-slide]')?.hidden)player.pause();});
   this.querySelector('[data-count]').textContent=`${String(this.index+1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
  }
  revealThumbnail(){
   const list=this.querySelector('.park-pdp-thumbnails');
   const active=list?.querySelector('[aria-pressed="true"]');
   if(!active)return;
   const box=list.getBoundingClientRect(),item=active.getBoundingClientRect();
   // Scroll only the thumbnail list, never the product page or its sticky gallery.
   if(list.scrollHeight>list.clientHeight){
    if(item.top<box.top)list.scrollTop+=item.top-box.top;
    else if(item.bottom>box.bottom)list.scrollTop+=item.bottom-box.bottom;
   }
   if(list.scrollWidth>list.clientWidth){
    if(item.left<box.left)list.scrollLeft+=item.left-box.left;
    else if(item.right>box.right)list.scrollLeft+=item.right-box.right;
   }
  }
  measure(){
   // One document scroll. The gallery sticks; product information stays in normal flow.
   this.dataset.scroll='false';this.panel.scrollTop=0;
   const header=document.querySelector('.section-header')||document.querySelector('#pageheader');
   const sticky=header&&['sticky','fixed'].includes(getComputedStyle(header).position)?header.getBoundingClientRect().height:0;
   const start=this.getBoundingClientRect().top+scrollY+(parseFloat(getComputedStyle(this).paddingTop)||0);
   this.style.setProperty('--pdp-sticky-top',`${sticky+12}px`);
   const buyButton=this.querySelector('[data-add]');
   if(buyButton)this.style.setProperty('--pdp-buy-button-width',`${buyButton.getBoundingClientRect().width}px`);
   this.style.setProperty('--pdp-gallery-height',`${this.querySelector('.park-pdp-gallery').getBoundingClientRect().height}px`);
   let mediaHeight=innerHeight-Math.max(start,sticky+12)-24;
   if(this.classList.contains('park-pdp-hero--1c')&&innerWidth>1000){
    // Vertical thumbnails need no space below the main image.
    const breadcrumb=this.querySelector('.park-pdp-breadcrumb');
    const breadcrumbHeight=breadcrumb?breadcrumb.getBoundingClientRect().height+(parseFloat(getComputedStyle(breadcrumb).marginBottom)||0):0;
    mediaHeight=innerHeight-Math.max(start+breadcrumbHeight,sticky+12)-24;
   }
   this.style.setProperty('--pdp-media-height',`${Math.max(180,mediaHeight)}px`);
  }
  anchor(){
   const header=document.querySelector('.section-header')||document.querySelector('#pageheader');
   const sticky=header&&['sticky','fixed'].includes(getComputedStyle(header).position)?Math.max(0,header.getBoundingClientRect().bottom):0;
   return Math.max(0,this.getBoundingClientRect().top+scrollY-sticky);
  }
  setupModels(){
   const models=[...this.querySelectorAll('model-viewer')];
   if(!models.length||!window.Shopify?.loadFeatures)return;
   this.modelPlayers=[];const signal=this.signal;
   const css='https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
   if(!document.querySelector(`link[href="${css}"]`)){const link=document.createElement('link');link.rel='stylesheet';link.href=css;document.head.append(link);}
   window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:error=>{
    if(error||signal.aborted||!window.Shopify.ModelViewerUI)return;
    for(const model of models){
     const player=new window.Shopify.ModelViewerUI(model);
     this.modelPlayers.push({model,player});
     if(model.closest('[data-slide]')?.hidden)player.pause();
    }
   }}]);
  }
  modalOpen(){if(document.querySelector('.cc-popup--visible'))return true;return [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .cc-popup--visible')].some(el=>!el.closest('[hidden],[aria-hidden="true"]')&&getComputedStyle(el).display!=='none'&&getComputedStyle(el).visibility!=='hidden'&&el.getClientRects().length>0);}
  scrollEnabled(e){return this.dataset.scroll==='true'&&!this.modalOpen()&&!document.body.classList.contains('reveal-mobile-nav')&&!e.target.closest('.cart-drawer,.cc-popup,.park-pdp-routine,.park-pdp-thumbnails,select,textarea,[contenteditable],video,iframe,model-viewer')&&this.getBoundingClientRect().bottom>0;}
  route(delta){const result=ParkPDPCore.route(scrollY,this.panel.scrollTop,this.panel.scrollHeight-this.panel.clientHeight,this.anchor(),delta);this.panel.scrollTop=result.panel;window.scrollTo({top:result.page,left:scrollX,behavior:'instant'});}
  revealHash(){if(location.hash){let target;try{target=document.getElementById(decodeURIComponent(location.hash.slice(1)));}catch(_){return;}if(target&&!this.contains(target))this.panel.scrollTop=this.panel.scrollHeight;}}
  disconnectedCallback(){
   this.resetSwipe();
   this.querySelectorAll('video').forEach(video=>video.pause());this.galleryReady=false;this.modelPlayers?.forEach(({player})=>player.destroy());this.modelPlayers=[];this.controller?.abort();this.resize?.disconnect();this.stickyObserver?.disconnect();cancelAnimationFrame(this.stickyFrame);this.stickyFrame=null;this.stickySizeObserver?.disconnect();document.documentElement.style.removeProperty('--park-pdp-buy-height');this.controller=null;}
 }
 customElements.define('park-pdp-hero',ParkPDP);
})();
